import { ROLE_LIST } from "./global";
import { HomeRoundedIcon, FavoriteRoundedIcon, FeedRoundedIcon } from '../components/customStyles/images';

export const PAGE = {
  index: 'frontpage',
  login: {
    id: 'login',
    path: '/login',
    name: 'Login',
    title: 'Login',
    nav: false,
    icon: null,
    disabled: false,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  frontpage: {
    id: 'frontpage',
    path: '/',
    name: '首頁',
    title: '首頁',
    nav: true,
    icon: <HomeRoundedIcon />,
    disabled: false,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  wishitem: {
    id: 'wishitem',
    path: '/wish-item',
    name: '用戶願望清單分析',
    title: '用戶願望清單分析',
    nav: true,
    icon: <FavoriteRoundedIcon />,
    disabled: false,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  marketingword: {
    id: 'marketing-word',
    path: '/marketing-word',
    name: '行銷文案生成工具',
    title: '行銷文案生成工具',
    nav: true,
    icon: <FeedRoundedIcon />,
    disabled: false,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  productList: {
    id: 'productList',
    path: '/marketing-word/productList',
    name: '選擇商品',
    title: '選擇商品',
    nav: null,
    icon: null,
    disabled: false,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  privacy: {
    id: 'privacy',
    path: '/privacy',
    name: '隱私權政策',
    title: '隱私權政策',
    nav: false,
    icon: null,
    disabled: null,
    allow: null
  },
  userTerm: {
    id: 'userTerms',
    path: '/user-terms',
    name: '服務條款',
    title: '服務條款',
    nav: false,
    icon: null,
    disabled: false,
    allow: null
  },
}